module.exports = __webpack_public_path__ + "static/img/bei.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bei.png
// module id = BkK1
// module chunks = 0